import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import React from 'react';
import { Link } from 'react-router-dom';

export default function GamesArea() {
  const {
    data: games,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['featured-web-games'],
    queryFn: async () => {
      const { data } = await axios.get(
        `https://be-staging.obigin.com/content/featured-web-games`
      );
      return data.data;
    },
  });

  if (isLoading) {
    return <div className="text-center text-white">Loading games...</div>;
  }

  if (isError) {
    return <div className="text-center text-red-500">Failed to load games.</div>;
  }

  return (
    <section className="featured-game-area position-relative pt-40">
      <div className="featured-game-bg" />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title title-style-three text-center mb-70">
              <h2>Browser <span>GAMES</span></h2>
              <p>
                Jump straight into action – no downloads, no installs. One click and you’re in the game.
              </p>
            </div>
          </div>
        </div>

        <div className="row featured-active">
          {games?.map((game) => (
            <Link  to={`/details/${game._id}`} key={game._id} className="col-lg-4 col-sm-6 grid-item">
              <div><div className="featured-game-item mb-30">
                <div className="featured-game-thumb">
                  <img 
                    style={{
                      height: '350px',
                      width: '100%',
                      objectFit: 'cover',
                    }} src={game.graphic || '/assets/img/images/default_game_thumb.jpg'} alt={game.name} />
                </div>
                </div>

               
              </div>
              
               <div className="featured-game-content">
                  <h4>
                    <Link to={game.link || '/#'}>
                      {game.name}
                    </Link>
                  </h4>
                  <div className="featured-game-meta">
                    <i className="fas fa-bell" />
                    <span>{game.genre?.[0] || 'Unknown'}</span>
                  </div>
                </div>

                <div className="featured-game-content featured-game-overlay-content">
                  <div className="featured-game-icon">
                    <img src="/assets/img/icon/featured_game_icon.png" alt="icon" />
                  </div>
                  <h4>
                    <Link to={game.link || '/#'}>
                      {game.name}
                    </Link>
                  </h4>
                  <div className="featured-game-meta">
                    <i className="fas fa-bell" />
                    <span>{game.genre?.[0] || 'Unknown'}</span>
                  </div>
                </div>
            </Link>
            
          ))}
          
        </div>

      </div>
    </section>
  );
}


